export const MODEL = {
	GPT_4: 'gpt-4o',
	GEMINI: 'gemini-2.0-flash',
} as const;
